import type { ComponentProps, ReactNode } from 'react';
import { Pressable } from '@gluestack-ui/themed';

type LabNavLinkProps = ComponentProps<typeof Pressable> & {
  href: string;
  children: ReactNode;
};

/** Web lab navigation link — Pressable with href for open-in-new-tab semantics on web. */
export function LabNavLink({
  href, children, ...props
}: LabNavLinkProps) {
  return (
    <Pressable {...props} {...({ href } as object)}>
      {children}
    </Pressable>
  );
}
